export const PAGE_SIZE = 20;

export const COLUNAS_ATIVOS = [
  { key: 'empreendimento', label: 'Empreendimento' },
  { key: 'quadra', label: 'Quadra' },
  { key: 'lote', label: 'Lote' },
  { key: 'corretor', label: 'Reservado para' },
  { key: 'imobiliaria', label: 'Imobiliaria' },
  { key: 'emissao', label: 'Reservado em' },
  { key: 'validade', label: 'Valido ate' },
  { key: 'fila', label: 'Qtd Fila' },
];
